import { IFile } from '@sdk/contracts';
import { Button } from 'antd';

import {
  UploadedFileInfo,
  FileNameWrapper,
  Wrapper,
  ButtonWrapper,
  IconWrapper
} from './UploadedFile.styles';

import { Icon } from '@/components/Icon';

type Props = {
  file: IFile;
  setFile: (file?: IFile) => void;
  maxWidth?: string;
  multiple?: boolean;
};

export const UploadedFile: React.FC<Props> = ({ file, setFile, maxWidth, multiple = false }) => {
  const handleOpenFile = () => window.open(file.url, '_blank');

  return (
    <ButtonWrapper>
      <Wrapper>
        <UploadedFileInfo onClick={handleOpenFile}>
          <IconWrapper i="DocumentAttachment" />
          <FileNameWrapper maxWidth={maxWidth}>{file?.name}</FileNameWrapper>
        </UploadedFileInfo>
        <Button
          type="link"
          icon={<Icon i="TrashCan" />}
          onClick={() => setFile(multiple ? file : undefined)}
        />
      </Wrapper>
    </ButtonWrapper>
  );
};
